import React from "react";
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
    Annotation
} from "react-simple-maps";
import { geoCentroid } from "d3-geo";
import { feature } from "topojson-client";
import worldMapData from "./features.json"; // Import world map data in topojson format

const projectData = [
    { continent: 'Africa', coordinates: [-20.2, 7.5], numberOfProjects: 10 },
    { continent: 'Europe', coordinates: [15.3, 54.7], numberOfProjects: 20 },
    // Add other continents with their respective coordinates and number of projects
];

const WorldMap = () => {
    return (
        <ComposableMap>
            <Geographies geography={worldMapData}>
                {({ geographies }) =>
                    geographies.map(geo => (
                        <Geography key={geo.rsmKey} geography={geo} />
                    ))
                }
            </Geographies>
            {/*{projectData.map(({ continent, coordinates, numberOfProjects }, i) => (*/}
            {/*    <Marker key={i} coordinates={coordinates}>*/}
            {/*        <circle r={10} fill="#F53" />*/}
            {/*        <text*/}
            {/*            textAnchor="middle"*/}
            {/*            y={15}*/}
            {/*            style={{ fontFamily: "system-ui", fill: "#5D5A6D" }}*/}
            {/*        >*/}
            {/*            {`${continent}: ${numberOfProjects}`}*/}
            {/*        </text>*/}
            {/*    </Marker>*/}
            {/*))}*/}
        </ComposableMap>
    );
};

export default WorldMap;
